/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { WorkTypeBase } from "../../../../schema/generated/WorkType";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class WorkTypeDataApi extends EntityDataApi<WorkTypeBase> {
  public readonly def = idbEntityDefs.WorkType;
}